import React from 'react';

export interface ChartHeaderProps {
  title: string;
  timeLabel: string;
  timeValue: string;
}

export function ChartHeader({
  title,
  timeLabel,
  timeValue,
}: ChartHeaderProps): React.JSX.Element {
  return (
    <div className="mb-4 flex flex-col md:flex-row md:justify-between md:items-start">
      <h3 className="text-xl font-bold text-high-emphasis-font mb-2 md:mb-0">
        {title}
      </h3>
      {/* Mobile layout: time value above label */}
      <h4 className="flex flex-col text-xl font-medium text-high-emphasis-font md:hidden">
        {timeValue}
        <span
          className="text-sm font-normal text-medium-emphasis-font"
          style={{ fontFamily: "'Open Sans', sans-serif" }}
        >
          {timeLabel}
        </span>
      </h4>
      {/* Desktop layout: label and time on same row, right-aligned */}
      <h4 className="hidden md:flex md:flex-row md:items-baseline md:gap-2 text-xl font-medium text-high-emphasis-font">
        <span
          className="text-sm font-normal text-medium-emphasis-font"
          style={{ fontFamily: "'Open Sans', sans-serif" }}
        >
          {timeLabel}
        </span>
        {timeValue}
      </h4>
    </div>
  );
}

export default ChartHeader;
